import { useGetInvoicesQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerBillingDataRpc.hooks';
import { useGetInvoicesQuery as usePreviewGetInvoicesQuery } from '../../__generated__/chirp/com/hubspot/commerce/buyer/portal/rpc/BuyerPreviewDataRpc.hooks';
import { getPreviewState } from '../utils/getPreviewState';
export function useInvoicesData(variables, overrides = {}) {
  const previewState = getPreviewState();
  const previewJwt = previewState.isPreview ? previewState.previewJwt : '';
  const {
    loading: previewLoading,
    error: previewError,
    data: previewData
  } = usePreviewGetInvoicesQuery({
    variables: Object.assign({
      previewJwt
    }, variables),
    skip: !previewState.isPreview
  });
  const {
    loading,
    error,
    data,
    previousData
  } = useGetInvoicesQuery(Object.assign({
    variables,
    skip: previewState.isPreview,
    // On every mount (including returning from invoice details), fire a background
    // network request while immediately returning cached data.
    fetchPolicy: 'cache-and-network',
    // When variables change (pagination), use cache-first so previously loaded
    // pages don't trigger a network call. For 'after-fetch', return currentFetchPolicy
    // (cache-and-network) so remounts continue to make a network call.
    nextFetchPolicy: (currentFetchPolicy, {
      reason
    }) => {
      if (reason === 'variables-changed') {
        return 'cache-first';
      }
      return currentFetchPolicy;
    }
  }, overrides));
  if (previewState.isPreview) {
    return {
      loading: previewLoading,
      error: previewError,
      data: previewData
    };
  }
  return {
    loading,
    error,
    data: data !== null && data !== void 0 ? data : previousData === null || previousData === void 0 ? void 0 : previousData.result
  };
}